const API_KEY = process.env.REACT_APP_DRIVE_API_KEY;

export const fetchFolders = async (parentFolderId) => {
  const query = encodeURIComponent(
    `'${parentFolderId}' in parents and mimeType = 'application/vnd.google-apps.folder'`
  );

  const url = `https://www.googleapis.com/drive/v3/files?q=${query}&key=${API_KEY}&fields=files(id,name)`;

  const response = await fetch(url);
  const data = await response.json();

  return data.files;
};

export const fetchAllImages = async (folderIdArr) => {
  const images = [];
  folderIdArr.forEach((folderId) => {
    images.push(...fetchImages(folderId));
  });
  return images;
};

export const fetchImages = async (folderId) => {
  // const API_KEY = process.env.REACT_APP_DRIVE_API_KEY;
  const url = `https://www.googleapis.com/drive/v3/files?q='${folderId}'+in+parents+and+mimeType+contains+'image/'&key=${API_KEY}&fields=files(id,name,webContentLink)`;

  const response = await fetch(url);
  const data = await response.json();

  return data.files.map((file) => ({
    id: file.id,
    name: file.name,
    url: `https://drive.google.com/thumbnail?id=${file.id}&sz=w2000-h2000`,
  }));
};
